  <header  class="dcf-header" id="dcf-header" role="banner">  
    <div id="header1"></div>
    <div id="logo1"></div>
    <div id="navGroup"></div>
    <div id="navMenu1"></div>
    <div id="includedContent"></div>
</header>